import { ContextOtherApiModel } from 'countable@model';

export class ContextOAModel {
  isCYSelected: boolean = false;
  isPY1Selected: boolean = false;
  isPY2Selected: boolean = false;
  selectedApiIds: ContextOtherApiModel[] = [];
}
